<template>
  <div id="userLayout" :class="['user-layout-wrapper']">
    <div class="container">
      <div class="login-box">
        <div class="top">
          <div class="header">
            <img :src="logo" class="logos" />
            <a href="/">
              <span class="title">{{ title }}</span>
            </a>
            <div class="desc">{{ desc }}</div>
          </div>
        </div>

        <router-view v-slot="{ Component }">
          <!-- <keep-alive> -->
            <component :is="Component"/>
          <!-- </keep-alive> -->
        </router-view>
      </div>
      <div class="footer">
        <div class="copyright">
          Copyright &copy; 2021 {{ title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config';

export default {
  name: 'UserLayout',
  components: {
    
  },
  data () {
    return {
      title: '',
      logo: '',
      config: config,
      desc: config.slogan,
    };
  },
  mounted () {
    document.body.classList.add('userLayout');

    let title = this.config.logoTitle;
    let logo = 'https://cdn.5laoban.com/statics/icon.png';
    this.title = title;
    this.logo = logo;
  },
  beforeUnmount () {
    document.body.classList.remove('userLayout');
  }
};
</script>

<style lang="less" scoped>
  #userLayout.user-layout-wrapper {
    height: 100%;

    &.mobile {
      .container {
        .login-box {
          width: 90%;
          padding: 33px 0;
        }
        .main {
          // max-width: 364px;
          width: 90%;
        }
      }
    }

    .container {
      box-sizing: border-box;
      width: 100%;
      min-height: 100vh;
      // background: url(~@/assets/bg.jpg) no-repeat center center;
      // background-size: cover;
      background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
      background-size: 100%;
      padding: 10% 0 144px;
      position: relative;

      a {
        text-decoration: none;
      }

      .top {
        text-align: center;

        .header {
          // height: 44px;
          // line-height: 44px;

          .logos {
            width: 114px;
            height: 114px;
            margin: 0 auto 26px;
            display: block;
          }

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 30px;
            color: rgba(0, 0, 0, .85);
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        // min-width: 260px;
        width: 364px;
        margin: 0 auto;
      }

      .login-box {
        width: 444px;
        padding: 33px 40px;
        margin: 0 auto;
        background-color: #ffffff;
        border-radius: 10px;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            // color: #ffffff;
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          // color: #ffffff;
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }
  }
</style>
